import _get from 'lodash/get';
import { createSelector } from 'reselect';

import { buildThemeWithConfig } from 'utils/branding';
import { createReducer } from 'utils/reducer';

import * as brandingActions from './actions';
import * as helpers from './reducerHelpers';

/**
 * Initialize the 'branding' state.
 *
 * @type {Object}
 */
export const INITIAL_STATE = {
    config: {},
    theme : buildThemeWithConfig()
};

/**
 * Build the map of 'branding' redux handlers.
 *
 * @type {Object}
 */
const branding = {
    [brandingActions.fetchBranding.SUCCESS]: helpers.fetchBrandingSuccess,
    [brandingActions.resetBranding.SUCCESS]: helpers.fetchBrandingSuccess
};

// Create and export the 'branding' reducer.
export default createReducer(INITIAL_STATE, branding);

/**
 * Get the company branding info
 *
 * @method getBranding
 * @param  {Object}     state The current state
 * @return {Array}
 */
export const getBranding = state => _get(state, 'branding', {});

/**
 * Get the branding config for the application
 *
 * @method getConfig
 * @param  {Object}   state The current state
 * @return {Array}
 */
export const getConfig = createSelector(
    [getBranding],
    branding => _get(branding, 'config', {})
);

/**
 * Get the theme for the application
 *
 * @method getTheme
 * @param  {Object}   state The current state
 * @return {Array}
 */
export const getTheme = createSelector(
    [getBranding],
    branding => _get(branding, 'theme', {})
);
